import React from "react";
import AfterLoginHeader from "../Layouts/AfterLoginHeader";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { Toast } from "primereact/toast";
import { getCustomerAddressById } from "../../store/Slice/customerAddressGetByIdSlice";
import {
  getCustomerAddressEditById,
  ResetCustomerAddressEditByIdState,
} from "../../store/Slice/customerAddressEditByIdSlice";

const UpdateAddress = () => {
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const toast = React.useRef(null);
  const location = useLocation();

  const addressvIdValue = location.state?.iAddressId;
  const addressvUniqueCodeValue = location.state?.vUniqueAddressCode;

  const customerUniqueCode = sessionStorage.getItem("Customer-vUniqueCode");
  const customerIdValue = sessionStorage.getItem("CustomerId");

  const [address, setAddress] = React.useState("");
  const [city, setCity] = React.useState("");
  const [zipCode, setZipCode] = React.useState("");
  const [state, setState] = React.useState("");
  const [country, setCountry] = React.useState("");

  const [loading, setLoading] = React.useState("");

  const { customerAddressAddData } = useSelector(
    (state) => state.customerAddressAddList
  );

  const { customerAddressbyIdListData } = useSelector(
    (state) => state.customerAddressByIdList
  );

  const { customerAddressEditByIdListData } = useSelector(
    (state) => state.customerAddressEditByIdList
  );

  const isCustomerLoggedIn =
    customerUniqueCode && customerUniqueCode !== "undefined";

  const handleCancelClick = () => {
    navigate("/profile");
  };

  React.useEffect(() => {
    if (customerIdValue && customerIdValue !== "undefined") {
      dispatch(
        getCustomerAddressById({
          iAddressId: +addressvIdValue,
        })
      );
    }
  }, [addressvIdValue, customerIdValue, dispatch]);

  const customerAddressListingById =
    customerAddressbyIdListData &&
    customerAddressbyIdListData.code === 200 &&
    customerAddressbyIdListData?.data;

  React.useEffect(() => {
    if (customerAddressListingById) {
      setAddress(customerAddressListingById?.tAddress || "");
      setCity(customerAddressListingById?.vCity || "");
      setZipCode(customerAddressListingById?.vZipCode || "");
      setState(customerAddressListingById?.vState || "");
      setCountry(customerAddressListingById?.vCountry || "");
    }
  }, [customerAddressListingById]);

  const handleEditAddress = React.useCallback(
    async (e) => {
      e.preventDefault();

      if (isCustomerLoggedIn) {
        dispatch(
          getCustomerAddressEditById({
            vUniqueCode: addressvUniqueCodeValue,
            iCustomerId: +customerIdValue,
            tAddress: address,
            vCity: city,
            vZipCode: zipCode,
            vState: state,
            vCountry: country,
          })
        );
        setLoading(true);
      }
    },
    [
      dispatch,
      isCustomerLoggedIn,
      addressvUniqueCodeValue,
      customerIdValue,
      address,
      city,
      state,
      country,
      zipCode,
    ]
  );

  React.useEffect(() => {
    if (!customerAddressEditByIdListData) return;

    const { code, message } = customerAddressEditByIdListData;

    if (code === 201) {
      toast.current.show({
        severity: "success",
        summary: message || "Address Updated successfully.",
        life: 2000,
        className: "custom-toast",
      });

      setTimeout(() => {
        dispatch(ResetCustomerAddressEditByIdState());
        setLoading(false);
        navigate("/profile");
      }, 2000);
    } else if (code === 400 || code === 404) {
      toast.current.show({
        severity: "error",
        summary: message || "Failed to Edit address.",
        life: 2000,
        className: "custom-toast-error",
      });
      setLoading(false);
    }
  }, [dispatch, navigate, customerAddressEditByIdListData]);

  return (
    <div className="dashboard">
      <Toast ref={toast} />
      <div className="dashboard-app">
        <AfterLoginHeader />

        <div className="dashboard-content">
          <div className="session-big-section">
            <div className="row">
              <div className="col-lg-12">
                <h2 className="dash-maintitle">Edit Address</h2>

                <div className="main-card profile-maincard">
                  <div className="dashprofile-card">
                    <div className="row">
                      <div className="col-xxl-10">
                        <div className="row justify-content-center">
                          <div className="col-xxl-10 col-xl-10">
                            <h3 className="dashsmall-bluetitle">
                              Contact Information
                            </h3>
                            <div className="login-form pt-0 pb-0">
                              <div className="row">
                                <div className="col-lg-6 col-md-6">
                                  <div className="login-inputDiv">
                                    <label
                                      htmlFor="exampleInputaddress"
                                      className="form-label"
                                    >
                                      Address
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      id="exampleInputaddress"
                                      placeholder="Enter Your Address"
                                      value={address}
                                      onChange={(e) =>
                                        setAddress(e.target.value)
                                      }
                                    />
                                  </div>
                                </div>

                                <div className="col-lg-6 col-md-6">
                                  <div className="login-inputDiv">
                                    <label
                                      htmlFor="exampleInputcity"
                                      className="form-label"
                                    >
                                      City
                                    </label>
                                    <input
                                      type="city"
                                      className="form-control"
                                      id="exampleInputcity"
                                      placeholder="Enter Your City"
                                      value={city}
                                      onChange={(e) => setCity(e.target.value)}
                                    />
                                  </div>
                                </div>
                                <div className="col-lg-6 col-md-6">
                                  <div className="login-inputDiv">
                                    <label
                                      htmlFor="exampleInputzipcode"
                                      className="form-label"
                                    >
                                      Zip Code
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      id="exampleInputzip"
                                      placeholder="Enter Your Zipcode"
                                      value={zipCode}
                                      onChange={(e) =>
                                        setZipCode(e.target.value)
                                      }
                                    />
                                  </div>
                                </div>
                                <div className="col-lg-6 col-md-6">
                                  <div className="login-inputDiv">
                                    <label
                                      htmlFor="exampleInputcity"
                                      className="form-label"
                                    >
                                      State
                                    </label>
                                    <input
                                      type="state"
                                      className="form-control"
                                      id="exampleInputstate"
                                      placeholder="Enter Your State"
                                      value={state}
                                      onChange={(e) => setState(e.target.value)}
                                    />
                                  </div>
                                </div>

                                <div className="col-lg-6 col-md-6">
                                  <div className="login-inputDiv">
                                    <label
                                      htmlFor="exampleInputcountry"
                                      className="form-label"
                                    >
                                      Country
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      id="exampleInputcountry"
                                      placeholder="Enter Your Country"
                                      value={country}
                                      onChange={(e) =>
                                        setCountry(e.target.value)
                                      }
                                    />
                                  </div>
                                </div>
                                <div className="col-lg-12">
                                  <div className="d-flex gap-3">
                                    {loading ? (
                                      <>
                                        {" "}
                                        <button
                                          className="success-orangebtn"
                                          type="button"
                                          disabled
                                        >
                                          <span
                                            className="spinner-border spinner-border-sm me-1 custom-spinner"
                                            role="status"
                                            aria-hidden="true"
                                          ></span>
                                          Loading...
                                        </button>
                                      </>
                                    ) : (
                                      <button
                                        type="submit"
                                        className="success-orangebtn"
                                        onClick={handleEditAddress}
                                      >
                                        Submit
                                      </button>
                                    )}
                                    <button
                                      className="success-orangebtn success-grayborderbtn"
                                      onClick={handleCancelClick}
                                    >
                                      Cancel
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateAddress;
